/**
 * The cart routes: D3 (`/cart`) and H3 (`/explore/2/grocery`).
 *
 * H3's route sits under `/explore` by docs/11's own map, but the screen is WP-D's. It is
 * registered here rather than in WP-C's explore group so that ownership follows the
 * screen. React Router ranks the static `/explore/2/grocery` above WP-C's dynamic
 * `/explore/:domain/:category`, so both can be mounted without an ordering rule.
 */
import type { RouteObject } from 'react-router-dom';
import { withSurfaceStates } from '../../states/boundary.js';
import { D3Cart } from './D3Cart.js';
import { H3Grocery } from './H3Grocery.js';

/**
 * WP-K · state branches. `withSurfaceStates` wraps every element of this group in the
 * boundary for its matrix column (transaction · লেনদেন); see
 * `apps/web/src/states/boundary.tsx`. It changes nothing about the healthy render — no
 * state resolves unless an API error body says so, so the screens below are untouched
 * and their fidelity gate still measures what it measured.
 */
export const cartRoutes: RouteObject[] = withSurfaceStates('transaction', [
  { path: '/cart', element: <D3Cart /> },
  { path: '/explore/2/grocery', element: <H3Grocery /> },
]);
